<script>
    import {querystring} from 'svelte-spa-router'
    import { onDestroy, onMount } from 'svelte';
    import Header from "./header.svelte";
    import breakpoints from "../utils/breakpoints";
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    import ResponsiveTable from '../utils/responsivetable3.svelte';

    // import Flatpickr from "../utils/Flatpickr.svelte";

    // setup
    const bp = breakpoints();

    let content_title = "Reviewing Gift Card";
    let gcid = "";
    let is_busy = false;

    let table_header_config = [
        {'t': 'Job', 'fm': 'a', 'a': true},
        {'t': 'Service Date', 'fm': 'sd', 'a': true},
        {'t': 'Value', 'fm': 'v', 'a': true},
        {'t': 'Used Date', 'fm': 'ud', 'a': true},
    ];

    let DELETE_ME_GIFT_CARD_REDEMPTIONS = [];

    // lifecycle items
    onMount(async () => {
        // console.log(`querystrning is ${$querystring}`)
        const params = new URLSearchParams($querystring)

        if (params.has("gcid")) {
            gcid = params.get("gcid");
        }
        // console.log( Array.from(params.keys()) );

    });


</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />
<div class="contentholder">
    <div class="buttonholder">
        <button class="edit" on:click={() => {push("#/GiftCard_Edit?gcid=" + gcid);}} ><i class="fas fa-edit"></i> Edit Gift Card</button>
        <button class="delete"><i class="far fa-trash-alt"></i> Delete Gift Card</button>
        <!-- <button class="reminder"><i class="far fa-clock"></i> Send Reminder</button> -->
    </div>

    <div class="section giftcardinfo">
        <div class="sectiontitle"><i class="fas fa-gift"></i>Gift Card Information</div>

        <div class="sectioninfo">
            <div class="column">
                <div class="infoitem">
                    <div class="infoitemtitle">Code:</div>
                    <div class="infoitemvalue">GIFT-DZZZNJGDSFEHVMT</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Description:</div>
                    <div class="infoitemvalue">Gift Card - from : admin@houseofyards.com, to: admin@houseofyards.com</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Is Gift:</div>
                    <div class="infoitemvalue">Yes</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Valid From:</div>
                    <div class="infoitemvalue">01-02-2021</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Valid To:</div>
                    <div class="infoitemvalue">03-12-2021</div>
                </div>
        
            </div>
    
            <div class="column">
                <div class="infoitem">
                    <div class="infoitemtitle">Type:</div>
                    <div class="infoitemvalue strikeout">Maximum Amount</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Value:</div>
                    <div class="infoitemvalue">$5.00</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Redemption Limit:</div>
                    <div class="infoitemvalue">0</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Redemptions:</div>
                    <div class="infoitemvalue">0</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Remaining Value:</div>
                    <div class="infoitemvalue">$5.00</div>
                </div>
        
            </div>
    
        </div>    


    </div>

    <div class="section redemptions">
        <div class="sectiontitle"><i class="fas fa-exchange-alt"></i> Gift Card Redemptions</div>

        <div class="sectioninfo">
            <ResponsiveTable 
            bind:table_header_config={table_header_config} 
            table_data={DELETE_ME_GIFT_CARD_REDEMPTIONS} 
            num_per_page={100} 
            bind:total_items={DELETE_ME_GIFT_CARD_REDEMPTIONS.length} 
            />
        
        </div>

    </div>


</div>

<style>
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "bh bh bh bh bh bh bh bh bh bh bh bh"
                             "gi gi gi gi gi gi gi gi gi gi gi gi"
                             "ri ri ri ri ri ri ri ri ri ri ri ri";
        gap: 20px;

    }
    .buttonholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        grid-area: bh;
    }
    .buttonholder button {
        width: 200px;
        margin-right: 20px;
        margin-top: 10px;
    }
    .buttonholder button.edit{
        background-color: #1c54b2;
        color: white;
    }
    .buttonholder button.delete{
        background-color: #ab003c;
        color: white;
    }
    .section_old {
        width: 100%;
    }

    .section_old .sectiontitle_old {
        width: 100%;
        font-size: 20px;
        color: white;
        background-color: #1769aa;
        margin-bottom: 10px;
    }
    .section_old .sectiontitle_old i{
        width: 25px;
        display: none;

    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .infoitem {
        display: flex;
        flex-direction: row;
    }
    .infoitem .infoitemtitle {
        width: 150px;
        font-weight: bold;
        text-align: right;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .infoitem .infoitemvalue {
        text-align: left;
        margin-left: 10px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .column{
        display: flex;
        flex-direction: column;
    }

    .giftcardinfo {
        grid-area: gi;
    }

    .redemptions {
        grid-area: ri;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "bh"
                                "gi"
                                "ri";
            gap: 20px;

        }
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button {
            width: 100%;
            /* text-align: left; */
        }

        .infoitem {
            width: 100%;
            display: flex;
            flex-direction: row;
        }
        .infoitem .infoitemtitle {
            width: 150px;
            font-weight: bold;
            text-align: right;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }
        .infoitem .infoitemvalue {
            text-align: left;
            margin-left: 10px;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }

        .sectioninfo {
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .column{
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        
    }

</style>